// extracted by mini-css-extract-plugin
export default {"price":"BundlePriceBlock-price","priceFrequency":"BundlePriceBlock-priceFrequency"};